import { FormControl, Grid, Switch } from '@mui/material'
import Typography from '@mui/material/Typography'
import React from 'react'
import ATRExitStrategyInput from './AtrExitStrategyInput'
import PeakValleyExitStrategyInput from './PeakValleyExitStrategyInput'
import ConditionalRatioInput from './ConditionalRatioInput'
import IncrementalExitStrategyInput from './IncrementalExitStrategyInput'
import DynamicTakeProfitInput from './DynamicTakeProfitInput'
import ExitStrategiesProps from './ExitStrategiesProps'
import HighLowStrategyInput from './HighLowStrategyInput'

const defaultDynamicTakeProfitInputData = {
  type: 'atr',
  atrRecalculationPeriod: 5,
  atrRecalculationTimeframe: 'minute',
  atrPeriod: 15,
  atrChartPeriod: 1,
  atrChartTimeframe: 'minute',
  allowIncrease: true,
  allowDecrease: true,
}

function DynamicTakeProfit(props: ExitStrategiesProps) {
  const { backtestSettingInputData, handleInputChange } = props

  return (
    <>
      <Grid item xs={12} display={'flex'} alignItems={'center'}>
        <Typography variant={'body1'}>Periodically modify take profit</Typography>
        <FormControl>
          <Switch
            checked={!!backtestSettingInputData.analyzeTrades.dynamicTakeProfit}
            onChange={(e) =>
              handleInputChange(
                'analyzeTrades.dynamicTakeProfit',
                e.target.checked ? defaultDynamicTakeProfitInputData : null
              )
            }
            color="primary"
          />
        </FormControl>
      </Grid>
      {backtestSettingInputData.analyzeTrades.dynamicTakeProfit ? (
        <DynamicTakeProfitInput {...props} />
      ) : null}
    </>
  )
}

export default function ExitStrategyInputs(props: ExitStrategiesProps) {
  const { backtestSettingInputData, periodicallyModifyTakeProfit } = props
  const { exitStrategy } = backtestSettingInputData.generateTrades

  switch (exitStrategy) {
    case 'atr':
      return (
        <>
          <ConditionalRatioInput {...props} />
          <ATRExitStrategyInput {...props} />
          {periodicallyModifyTakeProfit && <DynamicTakeProfit {...props} />}
        </>
      )
    case 'incremental':
      return (
        <>
          <ConditionalRatioInput {...props} />
          <IncrementalExitStrategyInput {...props} />
          {periodicallyModifyTakeProfit && <DynamicTakeProfit {...props} />}
        </>
      )
    case 'fixed':
      return (
        <>
          <ConditionalRatioInput {...props} />
          {periodicallyModifyTakeProfit && <DynamicTakeProfit {...props} />}
        </>
      )
    case 'peak_valley':
      return (
        <>
          <ConditionalRatioInput {...props} />
          <PeakValleyExitStrategyInput {...props} />
          {periodicallyModifyTakeProfit && <DynamicTakeProfit {...props} />}
        </>
      )
    case 'high_low':
      return (
        <>
          <ConditionalRatioInput {...props} />
          <HighLowStrategyInput {...props} />
          {periodicallyModifyTakeProfit && <DynamicTakeProfit {...props} />}
        </>
      )
    default:
      return null
  }
}
